import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import api from "../../../api/Base";

// Types.
import Action from '../../../types/Action';
import LoginTags from "../../../types/LoginsTags";

// Constants.
import { ACTIONS } from '../../../component/Constants';
import Alert from "../../../component/Alert";
import LoginApi from "../../../api/LoginApi";
import ConditionalRender from "../../../helpers/ConditionalRender";
import LoginsDataTable from "../../../types/LoginsDataTable";

function Detail(props: { actionId: string, loginId: number, tags: LoginTags[], refresh: Function, logins: LoginsDataTable[] }) {
    const [action, setAction] = useState<Action>(ACTIONS.CREATE);
    const [isError, setIsError] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(props.actionId === ACTIONS.DELETE.type);
    const [name, setName] = useState('');
    const [invalidName, setInvalidName] = useState<string>('');
    const [nameUsed, setNameUsed] = useState<boolean>(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [loading, setLoading] = useState<boolean>(true);

    const [selectedTags, setSelectedTags] = useState<LoginTags[]>([]);
    const [tagList, setTagList] = useState<LoginTags[]>([]);
    const [tagsToDelete, setTagsToDelete] = useState<LoginTags[]>([]);

    const history = useHistory();
    useEffect(() => {
        getAction();
        void getLoginDetails();
        void getAllTags();
    }, [props.actionId]);

    const getAllTags = async() => {
        let allTagsList: any[] = await LoginApi.getAllTags();
        setTagList(allTagsList)
    }

    const getLoginDetails = async() => {

        if (props.loginId) {
            let currentLogin: any[] = await LoginApi.getLogins(props.loginId)
            setName(currentLogin[0].name)
            setIsAdmin(currentLogin[0].admin)
        }
        setLoading(false)
    }

    useEffect(() => {
        let tagsSelected: any[] = []
        if (props.loginId) {
            tagsSelected = props.tags.filter(tag => tag.loginid === props.loginId)
        }
        setLoading(false)
        setSelectedTags(tagsSelected)

    }, [props.tags, props.loginId]);


    const getAction = () => {

        switch (props.actionId) {
            case 'create':
                setAction(ACTIONS.CREATE);
                break;

            case 'edit':
                setAction(ACTIONS.UPDATE);
                break;

            case 'delete':
                setAction(ACTIONS.DELETE);
                setDisabled(true);
                break;

            default:
                console.error('Unknown action requested', props.actionId);
                setIsError(true);
                break;
        }
    }

    const handleTags = (tagvalue: string) => {
        const currentTag = tagList.find(tag => tag.tagvalue === tagvalue);
        if (!currentTag) {
            console.error('Tag not found in allTags');
            return;
        }

        const tagExist = selectedTags.find(tag => tag.tagvalue === tagvalue);
        if (tagExist) {
            if (tagExist.id) {
                setTagsToDelete([...tagsToDelete, tagExist])
            }

            // Deselect the tag
            setSelectedTags(selectedTags.filter(tag => tag.tagvalue !== tagvalue));
        } else {
            currentTag.loginid = props.loginId
            const newTags = [...selectedTags, currentTag];
            setSelectedTags(newTags);
        }
    };

    const submitForm = async () => {
        setLoading(true);
        setErrorMessage('');
        setInvalidName('');

        if (!name) {
            setInvalidName('is-invalid');
            setLoading(false);
            return false;
        }

        if (props.logins.find(item => item.name === name) && action.type === 'create') {
            setNameUsed(true);
            setLoading(false);
            return false;
        }

        const loginData = [{
            id: props.loginId,
            name,
            admin: isAdmin,
        }];
        const newTags = selectedTags.filter(item => !item.hasOwnProperty('id'));

        let url = `/login`;
        let tagUrl = `/login/tag`;

        try {
            let result;
            let tagResult;
            let deleteTagResult;

            switch (action.type) {
                case 'create':
                    result = await api.post(url, loginData);
                    break;

                case 'update':
                    result = await api.put(url, loginData);
                    break;

                case 'delete':
                    result = await api.delete(url, { data: loginData });
                    break;

                default:
                    console.error('Unknown action requested', action);
                    return;
            }


            if (result.status !== 200) {
                setErrorMessage('Error creating or updating user');
                return;
            } else {
                // if create user was successful add tags

                // add loginid for tags is the user is newly created
                if (action.type === 'create' && result.data.length) {
                    const newLoginId = result.data[0]
                    // Update the loginid field for each object in newTags
                    newTags.forEach(tag => {
                        tag.loginid = newLoginId;
                    });
                }

                try {
                    if (tagsToDelete.length && action.type === 'update') {
                        deleteTagResult = await api.delete(tagUrl, { data: tagsToDelete });
                    }

                    if (tagsToDelete.length && action.type === 'delete') {
                        // delete all tags assigned to that user
                        let tagsSelected: any[] = []
                        if (props.loginId) {
                            tagsSelected = props.tags.filter(tag => tag.loginid === props.loginId)
                        }
                        deleteTagResult = await api.delete(tagUrl, { data: [tagsSelected] });
                        if (deleteTagResult?.status !== 200) {
                            setErrorMessage('Error deleting tags');
                            return;
                        }
                    }

                    if (newTags.length){
                        tagResult = await api.post(tagUrl, newTags);
                        if (tagResult?.status !== 200) {
                            setErrorMessage('Error creating tags');
                            return;
                        }
                    }
                } catch (tagError) {
                    console.error('Error handling tags:', tagError);
                    setErrorMessage('Error handling tags');
                    return;
                }
            }

            history.push('/admin/logins');
            props.refresh();

        } catch (error) {
            console.error('Error during API call:', error);
            setErrorMessage('An error occurred while submitting the form');
        } finally {
            setLoading(false);
        }
    }
    const handleNameBlur = (value: string) => {

        if (!value) {
            setInvalidName('is-invalid');
        } else if (props.logins.find(item => item.name === value) && action.type === 'create') {
            setNameUsed(true);
            setInvalidName('is-invalid');
            return false;
        } else {
            setInvalidName('is-valid');
            setNameUsed(false);
        }
        setName(value);
    }


    return (
        <div className="col">
            <div className="card">

                <div className="card-header">
                    <i className="fal fa-server fa-fw" aria-hidden="true"></i>
                    {action.title} user login
                </div>


                <div className="card-body">

                    {isError && (
                        <Alert
                            message="Sorry, but something went wrong and the requested action failed.  If the issue persists, please raise a support request."
                            heading={`Failed to ${action.title.toLowerCase()} login user`} variant="alert-danger"/>
                    )}
                    {errorMessage && (
                    <Alert
                        message={errorMessage}
                        heading='Error' variant="alert-danger"/>
                )}

                    <div className="row g-0 form">
                        {/* Name */}
                        <div className="col-xs-12 col-md-3">
                                <span className="required">
                                    <label htmlFor="name" className="reminder">Login name</label>
                                </span>
                        </div>

                        <div className="col-xs-12 col-md-6 col-lg-4">
                            <input
                                type="text"
                                id="name"
                                maxLength={250}
                                required
                                className={`form-control ${invalidName}`}
                                onChange={e => setName(e.target.value.replace(/\s+/g, ''))}
                                onBlur={e => handleNameBlur(e.target.value.replace(/\s+/g, ''))}
                                value={name}
                                defaultValue={name}
                                disabled={disabled}
                                data-lpignore={true}
                            />
                            {invalidName && (
                                <small className="text-danger">{nameUsed ? 'Login name already used.' : ''}</small>
                            )}
                        </div>
                        <div className="w-100"/>


                        <div className="col-xs-12 col-md-3">
                            <label className="reminder">Administrator</label>
                        </div>
                        <div className="col-xs-12 col-md-6 col-lg-3">
                            <div className='form-check form-switch'>
                                <input
                                    type="checkbox"
                                    id="disabled"
                                    className="form-check-input"
                                    disabled={disabled}
                                    onChange={() => setIsAdmin(!isAdmin)}
                                    checked={isAdmin}
                                    data-lpignore={true}
                                />
                            </div>
                        </div>

                        <div className="w-100"/>

                        <ConditionalRender if={isAdmin}>
                            <Alert message='Administrators have access to all datasources' heading="Tags" variant="alert-warning"/>
                        </ConditionalRender>
                        <div className="col-xs-12 col-md-3">
                            <label className="reminder">Tags</label>
                        </div>
                        <div className="col-xs-12 col-md-6 col-lg-3">
                            <div className="list-group">
                                {tagList.map((item, index) => (
                                    <label key={index} className="list-group-item">
                                        <input className="form-check-input me-2" type="checkbox" value={item.id}
                                               checked={selectedTags.filter(tag => item.tagname === tag.tagname && item.tagvalue === tag.tagvalue).length > 0}
                                               disabled={disabled || isAdmin}
                                               onChange={() => handleTags(item.tagvalue)}/>
                                        {`${item.tagname} : ${item.tagvalue}`}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="w-100"/>

                        <div className="col-12 actions">
                            <Link to="/admin/logins/" role="button" className="btn btn-secondary">
                                <i className="fal fa-times-circle fa-fw fa-sm"/><span>Cancel</span>
                            </Link>
                            <button onClick={() => submitForm()}
                                    disabled={loading || !name || nameUsed}
                                    className={`btn btn-${action.variant}`}>
                                <i className={`${action.icon} fa-sm`}/><span>{action.title}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Detail;
